import ThemeProviderWithTheme from './themeConfig/ThemeProviderWithTheme';

export default ThemeProviderWithTheme;
